// extracted by mini-css-extract-plugin
export default {"boxesContainer":"MultiTabBox_boxesContainer__zGX6o"};